import { render, staticRenderFns } from "./formSysRolePerm.vue?vue&type=template&id=eef3a82a&"
import script from "./formSysRolePerm.vue?vue&type=script&lang=js&"
export * from "./formSysRolePerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports